import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminSecurityPage from "@/pages/admin/AdminSecurityPage";

export const Route = createFileRoute("/_admin/admin/security")({
  head: () => pageHead("Admin · Security", "AKIVA admin · security portal.", "/admin/security", true),
  component: AdminSecurityPage,
});
